import { ForwardedRef, useEffect, useImperativeHandle, useRef } from 'react';

export const useTextAreaService = ({
  ref,
  value,
}: {
  ref: ForwardedRef<HTMLTextAreaElement>;
  value: string | number | readonly string[] | undefined;
}) => {
  const innerRef = useRef<HTMLTextAreaElement>(null);
  useImperativeHandle(ref, () => innerRef.current as HTMLTextAreaElement);

  const resize = () => {
    const el = innerRef.current;
    if (el) {
      el.style.height = 'auto';
      el.style.height = `${el.scrollHeight}px`;
    }
  };

  useEffect(() => {
    resize();
  }, [value]);

  return { innerRef };
};
